<template>
  <div class="container-fluid">
    <table class="table table-borderless table-condensed">
      <thead>
        <tr>
          <th class="col-1">File Name</th>
          <th class="col-1">Item Title</th>
          <th class="col-1">Item ID</th>
          <th class="col-2">File Format</th>
          <th class="col-1">Format Version</th>
          <th class="col-1">PUID</th>
          <th class="col-1">Size</th>
          <th class="col-1">Date Modified</th>
          <!-- <th class="col-2">Checksum</th>
          <th class="col-1">Checksum Type</th> -->
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ typesenseStore.currentFile.name }}</td>
          <td>{{ typesenseStore.currentFile.item_title }}</td>
          <td>{{ typesenseStore.currentFile.item_id }}</td>
          <td>{{ typesenseStore.currentFile.format }}</td>
          <td>{{ typesenseStore.currentFile.format_version }}</td>
          <td>{{ typesenseStore.currentFile.puid }}</td>
          <td>
            {{ $filters.formatSizeUnits(typesenseStore.currentFile.size) }}
          </td>
          <td>
            {{
              $filters.formatUnixDateTime(
                typesenseStore.currentFile.date_modified
              )
            }}
          </td>
          <!-- <td>{{ typesenseStore.currentFile.checksum }}</td>
          <td>{{ typesenseStore.currentFile.checksum_type }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useTypesenseStore } from "@/stores/typesense";

const typesenseStore = useTypesenseStore();
</script>

<style scoped>
.container-fluid {
  padding: 16px;
  padding-top: 20px;
  padding-bottom: 0;
}
.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td {
  padding: 1px;
}
</style>
